module.exports = __webpack_public_path__ + "static/media/class-end.741cba16.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dialog/class-end.png
// module id = 405
// module chunks = 1